// All JavaScript in here will be loaded client-side

// Expose components globally so ReactJS.NET can use them
import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { logger, crashReporter } from './middleware/general-middleware';
import productStylesReducer from './reducers/productstyle-reducers';
import mediaGalleryReducers from './reducers/media-gallery-reducers';
import blogArticleReducer from './reducers/blog-article-reducers';
import Components, { SiteForm } from './components';
import ErrorBoundry from './components/ErrorBoundry';
import ProductStylesContainer from './components/product-category/ProductStylesContainer';
import MediaGalleryContainer from './components/media-gallery/MediaGalleryContainer';
import BlogArticlesContainer from './components/blog-articles/BlogArticlesContainer';
import { restoreBlogFilterState } from './modules/blog-filter-utils';
import * as WidenUtils from './modules/widen-utils';
import * as FilterActions from './actions/filter-actions';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; /* eslint-disable-line no-underscore-dangle */

if (document.getElementById('site-form-container')) {
  ReactDom.render(
    React.createElement(SiteForm),
    document.getElementById('site-form-container'),
  );
}

if (document.getElementById('media-gallery-root')) {
  WidenUtils.init(() => {
    const mediaGalleryStore = createStore(
      mediaGalleryReducers, {
        initialState: {
          mediaItems: window.MediaGalleryData.mediaItems,
          modal: {
            active: false,
            item: window.MediaGalleryData.mediaItems[0],
          },
        },
        filters: window.MediaGalleryData.filters,
        mediaItems: window.MediaGalleryData.mediaItems,
        selectedFilters: {
          imagesVideosFilter: [],
          productLineFilter: [],
          colorRangeFilter: [],
          designStyleFilter: [],
          roomTypeFilter: [],
        },
        filterToggle: false,
        modal: {
          active: false,
          item: window.MediaGalleryData.mediaItems[0],
        },
        assetLoadComplete: false,
      },
      composeEnhancers(applyMiddleware(logger, crashReporter)),
    );

    WidenUtils.setMediaLoadCallback(() => {
      mediaGalleryStore.dispatch(FilterActions.addMediaItems());
    });

    WidenUtils.setMediaLoadCompleteCallback(() => {
      mediaGalleryStore.dispatch(FilterActions.assetLoadComplete(true));
    });

    ReactDom.render(
      React.createElement(ErrorBoundry, null, React.createElement(Provider, {
        store: mediaGalleryStore,
      }, React.createElement(MediaGalleryContainer))),
      document.getElementById('media-gallery-root'),
    );
  });
}

if (document.getElementById('product-styles-root')) {
  const productStyleStore = createStore(
    productStylesReducer, {
      initialState: {
        productStyles: window.ProductCategoryData.productStyles,
      },
      filters: window.ProductCategoryData.filters,
      productStyles: window.ProductCategoryData.productStyles,
      selectedFilters: {
        productLineFilter: [],
        colorRangeFilter: [],
        opacityFilter: [],
        priceFilter: [],
        energyEfficiencyFilter: [],
        choiceFilter: [],
      },
      filterToggle: false,
    },
    composeEnhancers(applyMiddleware(logger, crashReporter)),
  );

  ReactDom.render(
    React.createElement(ErrorBoundry, null, React.createElement(Provider, {
      store: productStyleStore,
    }, React.createElement(ProductStylesContainer))),
    document.getElementById('product-styles-root'),
  );
}

if (document.getElementById('blog-article-root')) {
  const restoredBlogState = restoreBlogFilterState(
    window.ArticleData.articleFilters,
    window.location.search,
  );
  const blogArticleStore = createStore(
    blogArticleReducer, {
      initialState: {
        articleItems: window.ArticleData.articleItems,
      },
      filters: restoredBlogState.filters,
      articleItems: window.ArticleData.articleItems,
      noResultsMessage: window.ArticleData.noResultsMessage,
      articlesListLinkText: window.ArticleData.articlesListLinkText,
      selectedFilters: restoredBlogState.selectedFilters,
      searchText: restoredBlogState.searchText,
      filterToggle: false,
    },
    composeEnhancers(applyMiddleware(logger, crashReporter)),
  );

  blogArticleStore.dispatch(FilterActions.searchSubmit(restoredBlogState.searchText));

  ReactDom.render(
    React.createElement(ErrorBoundry, null, React.createElement(Provider, {
      store: blogArticleStore,
    }, React.createElement(BlogArticlesContainer))),
    document.getElementById('blog-article-root'),
  );
}

export default Components;
